import { ConflictState } from '../useDetectedEntitiesStore';

export function filterConflictsByFields(
  conflicts: ConflictState[],
  fieldKeys: string[],
): ConflictState[] {
  return conflicts.map(conflict => ({
    ...conflict,
    conflictingEntityFields: Object.fromEntries(
      Object.entries(conflict.conflictingEntityFields).filter(([key]) => fieldKeys.includes(key)),
    ),
  }));
}
